import { useState, useEffect } from 'react';

/**
 * Logique du toggle cartes/tableau + responsive, dédupliquée de Eleve et AdminGroupe.
 * Au montage : détecte mobile (< breakpoint) et force la vue "mobile" si on y est.
 * Au resize : met seulement `isMobile` à jour (comportement historique préservé).
 * NE gère QUE l'état + le responsive — ni l'UI du switch, ni le rendu conditionnel.
 *
 * @returns {{ view: string, setView: Function, isMobile: boolean }}
 */
export default function useCardTableView({ defaultView = 'cards', mobileView = 'cards', breakpoint = 1280 } = {}) {
  const [isMobile, setIsMobile] = useState(false);
  const [view, setView] = useState(defaultView);

  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth < breakpoint);
    checkScreenSize();
    if (window.innerWidth < breakpoint) setView(mobileView);
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, [breakpoint, mobileView]);

  return { view, setView, isMobile };
}
